var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParamWrapper',_vm._b({on:{"input-data-closed":_vm.onDataInputMenuClose}},'ParamWrapper',_vm.wrapperProps,false),[_c(_vm.component,_vm._g(_vm._b({tag:"component"},'component',_vm.componentProps,false),_vm.componentListeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }